import { DefaultPassThrough } from '@primevue/core'
import { SelectPassThroughOptions } from 'primevue/select'
import type { SelectDesignTokens } from '@primeuix/themes/types/select'
import Dropdown from './Dropdown.vue'

export const DropdownPassthroughConfig: DefaultPassThrough<SelectPassThroughOptions> = {
  root: {
    class: 'tw-min-w-[60px] !tw-text-sm/[18px]'
  },
  overlay: {
    id: 'tw-wrapper'
  },
  label: {
    class: '!tw-text-sm/[18px]'
  }
}

export const DropdownStyleConfig: SelectDesignTokens = {
  root: {
    paddingX: 'var(--padding-sm)',
    paddingY: 'var(--padding-sm)',
    disabledBackground: 'var(--color-surface-neutral)',
    disabledColor: 'var(--color-text-subdued)',
    filledBackground: 'var(--color-surface-hover)',
    filledHoverBackground: 'var(--color-surface-hover)',
    placeholderColor: 'var(--color-text)',
    borderColor: 'var(--border-default-color)',
    borderRadius: 'var(--border-radius-sm)',
    hoverBorderColor: 'var(--border-hover-color)',
    focusBorderColor: 'var(--border-pressed-color)',
    sm: {
      fontSize: '14px',
      paddingX: 'var(--padding-sm)',
      paddingY: 'var(--padding-sm)'
    }
  },
  dropdown: {
    color: 'var(--color-text)',
    width: '2rem'
  },
  overlay: {
    borderColor: 'var(--border-default-color)',
    borderRadius: 'var(--border-radius-sm)'
  },
  list: {
    padding: 'var(--padding-sm)'
  },
  option: {
    color: 'var(--color-text)',
    padding: 'var(--padding-xs)',
    borderRadius: 'var(--border-radius-sm)',
    focusBackground: 'var(--color-surface-hover)',
    focusColor: 'var(--color-text)'
  },
  checkmark: {
    gutterStart: '0',
    gutterEnd: 'var(--padding-xs)'
  }
}

export default Dropdown
